/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AreaLocalWeather from './AreaLocalWeather';

/**
* The DashboardDeliveryComponent model module.
* @module model/DashboardDeliveryComponent
* @version 2020-12-7
*/
export default class DashboardDeliveryComponent {
    /**
    * Constructs a new <code>DashboardDeliveryComponent</code>.
    * 配送員向けコンポーネント
    * @alias module:model/DashboardDeliveryComponent
    * @class
    * @param type {module:model/DashboardDeliveryComponent.TypeEnum} 
    * @param areas {Array.<module:model/AreaLocalWeather>} 
    */

    constructor(type, areas) {
        
        
        this['type'] = type;
        this['areas'] = areas;
        
    }

    /**
    * Constructs a <code>DashboardDeliveryComponent</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DashboardDeliveryComponent} obj Optional instance to populate.
    * @return {module:model/DashboardDeliveryComponent} The populated <code>DashboardDeliveryComponent</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardDeliveryComponent();
                        
            
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('areas')) {
                obj['areas'] = ApiClient.convertToType(data['areas'], [AreaLocalWeather]);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/DashboardDeliveryComponent.TypeEnum} type
    */
    'type' = undefined;
    /**
    * @member {Array.<module:model/AreaLocalWeather>} areas
    */
    'areas' = undefined;



    /**
    * Allowed values for the <code>type</code> property.
    * @enum {String}
    * @readonly
    */
    static TypeEnum = {
        /**
         * value: "Delivery"
         * @const
         */
        "Delivery": "Delivery"    };

}
